import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { manageMatchesService } from "../../../../../commons";
import { FootballMatch } from "../../../../../commons/models/football/football-match";
import { PaginatedEnsueCollection } from "../../../../../ensue-react-system/utilities/paginated-ensue-collection";
import { MatchStatusEnum } from "../../../../../commons/enums/match-status-enum";
import { FootballMatchDetail } from "../../../../../commons/models/football/football-match-detail";

export interface IFootballMatchState {
  matches: PaginatedEnsueCollection<FootballMatchDetail>;
  matchesStatus: StatusEnum;
}

export interface IFootballMatchesOption {
  page?: number;
  perPage?: number;
  sort?: string;
  sortOrder?: string;
  status?: MatchStatusEnum;
  afterDate?: string;
  beforeDate?: string;
  hostTeamId?: number;
}

const initialState: IFootballMatchState = {
  matches: new PaginatedEnsueCollection<FootballMatchDetail>(),
  matchesStatus: StatusEnum.Idle,
};

export const fetchMatches = createAsyncThunk(
  "matches/fetchMatches",
  async (options: IFootballMatchesOption, thunkAPI) => {
    try {
      const matchList = await manageMatchesService.list(0, { ...options });
      return matchList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballMatchDetailSlice = createSlice({
  name: "footballMatchList",
  initialState: initialState,
  reducers: {
    cleanUpMatches(state) {
      state.matches = new PaginatedEnsueCollection<FootballMatchDetail>();
      state.matchesStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchMatches.pending, (state) => {
        state.matchesStatus = StatusEnum.Loading;
      })
      .addCase(fetchMatches.fulfilled, (state, action) => {
        state.matchesStatus = StatusEnum.Succeeded;
        state.matches = action.payload as PaginatedEnsueCollection<FootballMatchDetail>;
      })
      .addCase(fetchMatches.rejected, (state) => {
        state.matchesStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpMatches } = footballMatchDetailSlice.actions;
export default footballMatchDetailSlice.reducer;
